import { Button } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { baseUrl } from "../../Config/baseUrl";
import AddMenu from "./AddMenu";

export default function Menu() {
  const [data, setData] = useState([]);
  const [initialData, setInitailData] = useState(null);

  const getMenu = () => {
    axios
      .get(`${baseUrl}/blog/main-menu-api/`, {
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => setData(res.data?.data || []))
      .catch(() => toast.error("Failed to load menu"));
  };

  const deleteMenu = (id) => {
    axios
      .delete(`${baseUrl}/blog/main-menu-api/`, {
        data: { menu_id: id },
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        toast.success(res?.data?.message);
        getMenu();
      })
      .catch(() => toast.error("Delete failed"));
  };

  useEffect(() => {
    getMenu();
  }, []);

  return (
    <div className="w-full ">
      <p className="my-4  sm:my-0 text-2xl md:text-4xl font-bold text-center text-blue-900 underline">
        Menu
      </p>

      <div className="flex justify-end mb-2">
        <AddMenu
          getMenu={getMenu}
          initialData={initialData}
          setInitailData={setInitailData}
        />
      </div>

      {/* SINGLE TABLE WITH HORIZONTAL SCROLL */}
      <div className="w-full overflow-x-auto">
        <table className="min-w-[800px] w-full border border-gray-300 text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-3 py-1 border">#</th>
              <th className="px-3 py-1 border">Menu</th>
              <th className="px-3 py-1 border">Image</th>
              <th className="px-3 py-1 border">Slider</th>
              <th className="px-3 py-1 border">Page</th>
              <th className="px-3 py-1 border">Actions</th>
            </tr>
          </thead>

          <tbody>
            {data.map((item, index) => (
              <tr key={item.id} className="hover:bg-gray-50 transition">
                <td className="px-3 py-1 border">{index + 1}</td>

                <td className="px-3 py-1 border font-medium">{item.name}</td>

                <td className="px-3 py-1 border">
                  <img
                    src={item.image}
                    alt=""
                    className="h-8 w-8 rounded object-cover border"
                  />
                </td>

                <td className="px-3 py-1 border">
                  {item.slider_title || "--"}
                </td>

                <td className="px-3 py-1 border">{item.page_title || "--"}</td>

                <td className="px-3 py-1 border">
                  <div className="flex gap-2">
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={() => setInitailData(item)}
                    >
                      Edit
                    </Button>
                    <Button
                      size="small"
                      variant="outlined"
                      color="error"
                      onClick={() => deleteMenu(item.id)}
                    >
                      Delete
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
